import * as $ from 'jquery';
import * as app from 'CMS/core/application';
import { BaseRepository } from 'visuris/Data/Repositories/BaseRepository';
import ActionResult from 'visuris/Data/DTOs/ActionResult';
import FavoriteVoyage from 'visuris/Data/Entities/FavoriteVoyage';

export default class FavoriteVoyagesRepository extends BaseRepository<FavoriteVoyage> {

    // See constructor
    private GETFAVORITEVOYAGES = "";
    private GETFAVORITEVOYAGESBYNAME = "";
    private REMOVEFAVORITEVOYAGE = "";
    private ADDFAVORITEVOYAGE = "";
    private UPDATEFAVORITEVOYAGE = "";

    constructor() {
        super();
        this.GETFAVORITEVOYAGES = app.formatLocationUrl("~/visuris/api/Favorites/Voyages/GetAllFavoriteVoyages");
        this.GETFAVORITEVOYAGESBYNAME = app.formatLocationUrl("~/visuris/api/Favorites/Voyages/GetAllFavoriteVoyagesByName?name=");
        this.REMOVEFAVORITEVOYAGE = app.formatLocationUrl("~/visuris/api/Favorites/Voyages/Remove");
        this.ADDFAVORITEVOYAGE = app.formatLocationUrl("~/visuris/api/Favorites/Voyages/Add");
        this.UPDATEFAVORITEVOYAGE = app.formatLocationUrl("~/visuris/api/Favorites/Voyages/Update");
    }

    public list(): Promise<FavoriteVoyage[]> {
        return new Promise<FavoriteVoyage[]>((resolve, reject) => {
            var $get = $.get(this.GETFAVORITEVOYAGES);
            $get.then((data) => {
                var registrations: FavoriteVoyage[] = [];
                for (let i = 0; i < data.length; i++) {
                    var item = data[i];
                    registrations.push(FavoriteVoyagesRepository.fromDTO(item));
                }
                resolve(registrations);
            }, () => {
                reject();
            });
        });
    }
    public get(id: string): Promise<FavoriteVoyage> {
        return null;
    }

    public getFavoriteVoyagesByName(name: string): Promise<FavoriteVoyage[]> {
        return new Promise<FavoriteVoyage[]>((resolve, reject) => {
            const $get = $.get(this.GETFAVORITEVOYAGESBYNAME + name);
            $get.then((data) => {
                const voyages: FavoriteVoyage[] = [];
                for (const item of data) {
                    voyages.push(FavoriteVoyagesRepository.fromDTO(item));
                }
                resolve(voyages);
            }, () => {
                reject();
            });
        });
    }

    public remove(isrs: string): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            var $post = $.post({ url: this.REMOVEFAVORITEVOYAGE, data: JSON.stringify(isrs), contentType: 'application/json' });
            $post.then((data) => {
                resolve(true);
            }, () => {
                reject();
            });
        });
    }

    public saveFavoriteVoyage(favoriteVoyage: FavoriteVoyage): Promise<ActionResult> {
        return new Promise<ActionResult>((resolve, reject) => {
            const item = FavoriteVoyagesRepository.toDTO(favoriteVoyage);
            const $post = $.post({ url: this.ADDFAVORITEVOYAGE, data: JSON.stringify(item), contentType: 'application/json' });
            $post.then((data) => {
                resolve(data);
            }, (error) => {
                reject(error);
            });
        });
    }

    public updateFavoriteVoyage(favoriteVoyage: FavoriteVoyage): Promise<ActionResult> {
        return new Promise<ActionResult>((resolve, reject) => {
            const item = FavoriteVoyagesRepository.toDTO(favoriteVoyage);
            const $post = $.post({ url: this.UPDATEFAVORITEVOYAGE, data: JSON.stringify(item), contentType: 'application/json' });
            $post.then((data) => {
                resolve(data);
            }, (error) => {
                reject(error);
            });
        });
    }

    public static fromDTO(item: any): FavoriteVoyage {
        const favVoyage = new FavoriteVoyage();
        favVoyage.id = item.id;
        favVoyage.stops = item.stops;
        favVoyage.favoriteVoyageName = item.favoriteVoyageName;
        favVoyage.shipLength = item.shipLength;
        favVoyage.shipWidth = item.shipWidth;
        favVoyage.shipDraught = item.shipDraught;
        favVoyage.shipHeight = item.shipHeight;
        favVoyage.shipSpeed = item.shipSpeed;
        favVoyage.shipTonnage = item.shipTonnage;
        favVoyage.recreationalBoating = item.recreationalBoating;
        favVoyage.professionalShipping = item.professionalShipping;
        favVoyage.passengerShip = item.passengerShip;
        favVoyage.loaded = item.loaded;
        favVoyage.adn = item.adn;
        favVoyage.convoy = item.convoy;
        favVoyage.pusher = item.pusher;

        return favVoyage;
    }

    public static toDTO(item: FavoriteVoyage): any {
        const favVoyage: any = {
            id: item.id,
            stops: item.stops.map(stop => stop.isrs).join(','),
            favoriteVoyageName: item.favoriteVoyageName,
            shipLength: item.shipLength,
            shipWidth: item.shipWidth,
            shipDraught: item.shipDraught,
            shipHeight: item.shipHeight,
            shipSpeed: item.shipSpeed,
            shipTonnage: item.shipTonnage,
            recreationalBoating: item.recreationalBoating,
            professionalShipping: item.professionalShipping,
            passengerShip: item.passengerShip,
            loaded: item.loaded,
            adn: item.adn,
            convoy: item.convoy,
            pusher: item.pusher,
            userId: null,
        };
        return favVoyage;
    }
}

